import React from "react"

// NOTE: This file should be replace toolbar-menu.js once the new toolbar is fully released
const ToolbarMenu = ({ close, editor, component }) => {
  const Menu = component

  return (
    <div className="absolute left-0 shadow" style={{ top: 40 }}>
      <Menu close={close} editor={editor} />
    </div>
  )
}

export default ToolbarMenu
